import type { DeepPartial } from '@luna/utils-ts';

import type { Print } from '../../types/Print';

export const printATFeatureConfig: DeepPartial<Print> = {
    infoCheckBoxes: true,
    showAccountInfo: true,
    showInfoFilter: true,
    showSettlementAccount: true,
};
